import { Link } from 'react-router';
import { getSolutionWorks } from '../data';

/**
 * 解答集の作品一覧 (kind = "solutions" の子要素ページに表示)。
 * カテゴリトップの子要素一覧と同じ導線: 作品ごとに見出しリンク + 説明。
 */
export function WorksList() {
  return (
    <>
      {getSolutionWorks().map((work) => (
        <div key={work.key}>
          <h3>
            <Link to={`/solutions/${work.key}`}>{work.title}</Link>
          </h3>
          {work.description.map((paragraph, i) => (
            <p key={i}>{paragraph}</p>
          ))}
        </div>
      ))}
    </>
  );
}
